import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import breakPoints from 'theme/Media';
import oldBreakpoints from 'constants/breakpoints';

export const modifiers = {
  backgroundGray2: ({ theme }) => ({
    styles: `
      .TooltipStyled {
        background-color: ${theme.farmProject.gray_2};
      }
    `,
  }),
  showTip: () => ({
    styles: `      
      .TooltipStyled {
        display: block;
      }
      .Icon:after {
        display: block;
      }
    `,
  }),
};

export const contentModifiers = {
  filledArow: () => ({
    styles: `      
      transform: translate(-50%, 50%);
      padding: 0.75rem 1rem;
      max-width: 10rem;
      border: none;
      filter: drop-shadow(4px 2px 14px #00000025);

      &:after {
        content: '';
        display: block;
        width: 1rem;
        height: 1rem;
        background-color: white;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
      }

      .Text {
        margin-top: 0;
      }
    `,
  }),
};

export const TooltipStyled = styled.div.attrs({
  className: 'TooltipStyled',
})`
  max-width: 30rem;
  background-color: ${({ theme }) => theme.farmProject.gray_3};
  padding: 0.75rem 1.125rem;
  border: solid 1px ${({ theme }) => theme.farmProject.dark_gray};
  border-radius: 0.5rem;
  margin: auto;
  display: none;
  z-index: 1;
  width: 56vw;
  position: relative;
  transform: translate(-50%, -10%);

  .Text {
    font-weight: normal;
    display: block;
  }

  @media ${breakPoints.medium_break} {
    width: 53vw;
    position: relative;
    transform: translate(-30%, -5%);
  }

  @media (min-width: ${oldBreakpoints.MOBILE}px) {
    width: 31vw;
    transform: translate(-61%, -4%);
  }

  @media ${breakPoints.large_break} {
    width: 20vw;
    transform: translate(-64%, -3%);
    left: 1rem;
  }

  ${applyStyleModifiers(contentModifiers)}
`;

export const TipIconWrapper = styled.div.attrs({
  className: 'TipIconWrapper',
})`
  display: block;
  width: 1rem;
  height: 1rem;
  top: 3rem;
  right: 2.5rem;
  transition: all 0.2s ease-in-out;
  z-index: 1;

  .Icon {
    width: 10px;
    height: 34px;
    top: 2px;
    left: 4px;

    &:after {
      content: '';
      width: 1px;
      height: 33px;
      background-color: ${({ theme }) => theme.farmProject.dark_gray};
      display: none;
      position: relative;
      margin-top: 0.75rem;
      margin-left: 0.3rem;
    }

    svg {
      top: 18%;
      g {
        fill: transparent;

        circle:first-of-type {
          r: 7.5;
        }
      }
    }
  }

  &:focus, &:focus-within {
    .TooltipStyled {
      display: block;
    }
    .Icon:after {
      display: block;
    }
  }

  @media ${breakPoints.large_break} {
    &:hover {
      .TooltipStyled {
        display: block;
      }
      .Icon:after {
        display: block;
      }
    }
  }

  ${applyStyleModifiers(modifiers)}
`;
